export * from "./getSticksMatrixColorVariants";
